<template>
  <div class="mt-3 container">
    <div class="card text-center mb-4">
      <div class="card-body">
        <h4> You have been selected to participate in the following Tribunals</h4>
      </div>
      <table class="table b-table table-striped table-hover" aria-busy="false" aria-rowcount="2">
        <thead>
        <th aria-colindex="1" @click="sort('description')">
          Description
        </th>
        <th aria-colindex="2" @click="sort('reward')">
          Reward
        </th>
        <th aria-colindex="3" class="text-center"></th>
        </thead>
        <tbody>
        <template v-for="tribunal in sortedTribunals">
          <tr>
            <td aria-colindex="1">{{ tribunal.description }}</td>
            <td aria-colindex="2" class="mr-2">
              {{ tribunal.reward }}
              <span class="text-uppercase">{{ tribunal.amountType }}</span>
            </td>
            <td aria-colindex="3">
              <button class="btn btn-success" @click="acceptTribunal(tribunal.id)">Accept</button>
              <button class="btn btn-danger" @click="declineTribunal(tribunal.id)">Decline</button>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

  import {mapGetters} from 'vuex'

  export default {
    name: "TribunalsList",
    data() {
      return {
      }
    },
    methods: {
      sort(col) {
        let newSortDirState;
        if (col === this.currentSort) {
          newSortDirState = this.currentSortDir === 'asc' ? 'desc' : 'asc';
        }
        this.$store.commit('Tribunal/changeSortDir', newSortDirState);
        this.$store.commit('Tribunal/changeCurrentSort', col);
      },
      acceptTribunal(tribunalId) {
        this.$router.push({name: 'tribunalDetails', params: {id: tribunalId}})
      },
      declineTribunal(tribunalId) {
        //TODO (Nikolay): Code The logic behind Declining a Tribunal
        console.log(`Tribunal with ID ${tribunalId} declined.`);
      }
    },
    computed: {
      ...mapGetters('Tribunal', ['sortedTribunals', 'currentSort', 'currentSortDir']),
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tribunals/TribunalsList.vue